import { api, type DemoConfig } from '@/api/client';

let config: DemoConfig | null = null;

export async function loadDemoConfig(): Promise<DemoConfig> {
  config = await api.config();
  return config;
}

export function getDemoConfig(): DemoConfig {
  if (!config) throw new Error('config não carregada — chame loadDemoConfig() no bootstrap');
  return config;
}
